import { memo } from 'react';
import { DigitalRetailOverlayCTA } from 'reaxl-wallet';
import { EmailCTA } from 'reaxl-email';
import { Label } from 'reaxl';
import LendingOptionsCTA from './LendingOptionsCTA.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
const FinancingCallToAction = /*#__PURE__*/memo(_ref => {
  let {
    creditApp,
    digitalRetailProps,
    enableCreditApp,
    enableMyWallet,
    handleEmailCTAClick,
    handleLendingOptionsCTA,
    hideSendOfferCTA,
    isDRAccelerate,
    isOwnerFinancingSubmitted,
    listingId,
    onFinancingCTAClick
  } = _ref;
  const isAmdCreditApp = enableCreditApp && isDRAccelerate;
  const isSacaCreditApp = enableCreditApp && !isDRAccelerate && !!onFinancingCTAClick;
  const {
    onCTAClick,
    ctaLabel,
    partner = '',
    url
  } = creditApp || {};
  let creditCTAProp = {
    glyph: 'offsite'
  };
  if (partner === 'psx') {
    creditCTAProp = {
      glyph: 'chevron-right',
      target: '_self',
      rel: 'follow'
    };
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [handleLendingOptionsCTA && !isDRAccelerate && /*#__PURE__*/jsx(LendingOptionsCTA, {
      enableMyWallet: enableMyWallet,
      callback: handleLendingOptionsCTA
    }), !enableCreditApp && !isDRAccelerate && !!creditApp && /*#__PURE__*/jsx(LendingOptionsCTA, {
      enableMyWallet: enableMyWallet,
      callback: onCTAClick,
      label: ctaLabel,
      cmp: `${partner.toLowerCase()}-ca`,
      href: url,
      ...creditCTAProp
    }), isAmdCreditApp && /*#__PURE__*/jsx(DigitalRetailOverlayCTA, {
      ...digitalRetailProps,
      buttonStyle: "primary",
      uiContext: "creditApp"
    }), isSacaCreditApp && /*#__PURE__*/jsxs(Fragment, {
      children: [!isOwnerFinancingSubmitted && /*#__PURE__*/jsx(LendingOptionsCTA, {
        enableMyWallet: enableMyWallet,
        callback: onFinancingCTAClick,
        label: "Apply for Financing",
        cmp: "std-ca"
      }), isOwnerFinancingSubmitted && !hideSendOfferCTA && /*#__PURE__*/jsx(EmailCTA, {
        listingId: listingId,
        type: "link",
        labelKey: "creditStatus",
        showIcon: false,
        onClick: handleEmailCTAClick
      }, "send-to-dealer-cta")]
    }), (isAmdCreditApp || isSacaCreditApp) && /*#__PURE__*/jsx("div", {
      className: "margin-top-2",
      children: /*#__PURE__*/jsxs(Label, {
        bsStyle: "info-inverse",
        className: "display-inline-flex align-items-baseline",
        children: [/*#__PURE__*/jsx("span", {
          className: "margin-right-1 glyphicon glyphicon-clock",
          "aria-hidden": "true"
        }), "Saves 45 min. at dealership"]
      })
    })]
  });
});
export { FinancingCallToAction as default };
